import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../api/user.service';
import { ApiService } from '../api/api.service';
import { AuthService } from '../api/auth.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import * as LoginActions from '../user/login.actions';

@Component({
  selector: 'app-register-modal',
  template: `
    <div class="modal-header d-block text-center container">
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="row" *ngIf="!codeSent">
        <h1 class="col-12">Create a profile</h1>
        <p class="col-12">
          Let&#8217;s stay connected and get to know each other.
        </p>
      </div>
      <div class="row" *ngIf="codeSent">
        <h1 class="col-12">Enter code</h1>
        <p class="col-12">
          Please check your email to get your security code and enter it below.
        </p>
      </div>
      <div class="message">{{ message }}</div>
    </div>
    <div class="modal-body container" *ngIf="!codeSent">
      <div class="row mb-3">
        <text-field
          class="col-6"
          label="First Name"
          type="text"
          autocomplete="given-name"
          [(ngModel)]="firstname"
          [showValidation]="showValidation"
          [required]="true"
        >
        </text-field>
        <text-field
          class="col-6"
          label="Last Name"
          type="text"
          autocomplete="family-name"
          [(ngModel)]="lastname"
          [showValidation]="showValidation"
          [required]="true"
        >
        </text-field>
      </div>
      <div class="row mb-3">
        <text-field
          class="col-12"
          label="Email"
          type="text"
          autocomplete="email"
          [(ngModel)]="email"
          [showValidation]="showValidation"
          [required]="true"
        >
        </text-field>
      </div>
      <div class="row mb-3">
        <password-field
          class="col-12"
          label="Password"
          type="password"
          [(ngModel)]="password"
          (ngModelChange)="onPasswordChange()"
          [showValidation]="showValidation"
          [errors]="errors"
          [required]="true"
        >
        </password-field>
      </div>
      <div class="row">
        <text-field
          class="col-12"
          label="Confirm Password"
          type="password"
          [(ngModel)]="confirm"
          (ngModelChange)="onPasswordChange()"
          [showValidation]="showValidation"
          [required]="true"
        >
        </text-field>
        <p class="col-12 has-error" *ngIf="showMismatch">
          Passwords don&#8217;t match
        </p>
      </div>
      <div class="container">
        <div class="d-flex justify-content-center">
          <button
            type="submit"
            (click)="register()"
            class="btn btn-primary btn-login"
            aria-label="register"
          >
            Register
          </button>
        </div>
        <div class="d-flex justify-content-center">
          <div class="horizontal-divider">
            <span>or</span>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <button
            class="btn btn-primary google"
            (click)="social('google')"
            aria-label="Sign in with Google"
          >
            Sign in with Google
          </button>
        </div>
      </div>
    </div>
    <div class="modal-body container" *ngIf="codeSent">
      <div class="row mb-3">
        <text-field
          class="col-12"
          label="Enter the code you received"
          type="text"
          [(ngModel)]="code"
          [showValidation]="showCodeValidation"
          [minLength]="1"
          [maxLength]="6"
          [required]="true"
        >
        </text-field>
      </div>
      <div class="d-flex justify-content-center">
        <button
          type="submit"
          (click)="loginCode()"
          class="btn btn-primary btn-login"
          aria-label="verify code"
        >
          GO
        </button>
      </div>
      <div class="d-flex justify-content-center">
        <a (click)="resendToken()" class="link" aria-label="resend code"
          >Resend Code</a
        >
      </div>
    </div>
  `,
  styles: []
})
export class RegisterModalComponent implements OnInit {
  loggedIn: Boolean = false;
  unableVerify: Boolean = false;
  d = this.modal.dismiss;
  showValidation = false;
  showCodeValidation = false;
  showMismatch = false;
  firstname;
  lastname;
  email;
  password;
  confirm;
  codeSent = false;
  code;
  message = '';
  token = '';
  errors;

  constructor(
    private api: ApiService,
    private auth: AuthService,
    private user: UserService,
    public modal: NgbActiveModal,
    private store: Store
  ) {}
  ngOnInit() {}
  social(type) {
    this.user.social(type, res => {
      if (res.timedOut) {
        this.unableVerify = true;
      } else {
        const data = res;
        this.loggedIn = true;
        this.auth.setUser(data);
        this.store.dispatch(new LoginActions.LoginUser(data));
        this.auth.startTokenCheck();
        this.modal.close();
      }
    });
  }
  register() {
    this.showValidation = true;
    if (
      !this.email ||
      !this.firstname ||
      !this.lastname ||
      !this.password ||
      !this.confirm
    ) {
      return;
    }

    // if email is already in use, we return a specific error
    // message and we're going to replace it.
    this.auth
      .postRequest({
        firstname: this.firstname,
        lastname: this.lastname,
        username: this.email,
        password: this.password,
        confirm: this.confirm,
        mode: 'create'
      })
      .pipe(
        catchError(err =>
          of(
            (this.errors =
              err.error.message === 'New user could not be created.'
                ? { message: 'Email entered is already in use.' }
                : err.error)
          )
        )
      )
      .subscribe((item: any) => {
        if (item.token) {
          this.codeSent = true;
          this.token = item.token;
        }
      });
  }
  onPasswordChange() {
    if (!this.password || !this.confirm) {
      return;
    }
    if (this.password !== this.confirm) {
      this.showMismatch = true;
    } else {
      this.showMismatch = false;
    }
  }

  loginCode() {
    this.showCodeValidation = true;
    const _length = this.code.length;
    if (_length < 1 || _length > 6) {
      return;
    }
    this.auth.postValidate(this.token, this.code).subscribe(
      item => {
        this.auth.setUser(item);
        this.store.dispatch(new LoginActions.LoginUser(item));
        this.auth.startTokenCheck();
        this.modal.close();
      },
      error => {
        this.message = 'Invalid Code';
      }
    );
  }
  resendToken() {
    this.auth
      .postRequest({
        firstname: this.firstname,
        lastname: this.lastname,
        username: this.email,
        password: this.password,
        confirm: this.confirm
      })
      .subscribe((item: any) => {
        this.codeSent = true;
        this.token = item.token;
        this.message = 'Resent security code';
      });
  }
}
